<template>
  <div id="home" class="all_in">
    <!-- all_in -->
    <div class="header_all">
      <div class="header_left">
        <router-link :to="{ name: 'home'}"><img src="/../static/images/logo.jpg"></router-link>
      </div>
      <div class="header_right">
        <ul>
          <li><a @click="setLocale('CH')">中文版</a></li>
          <li><a @click="setLocale('EN')">ENGLISH</a></li>
        </ul>
        <div class="mt15">
          <gcse:search></gcse:search>
        </div>
      </div>
      <div class="fix"></div>
    </div>
    <div class="nav_all">
      <div class="disp_cell">
        <ul class="drop-down-menu">
          <li v-for="(itemone,index) in menu" :key="index">
            <a v-if="!itemone.children[0] && checkTitle(itemone)" @click="linkUrl(itemone)">{{showTitle(itemone)}}</a>
            <a v-if="itemone.children[0]">{{showTitle(itemone)}}</a>
            <ul style="width: 139px;" v-if="itemone.children[0]">
              <li v-for="(itemtwo,index) in itemone.children" :key="index">
                <a style=" padding:0;" @click="linkUrl(itemtwo)">{{showTitle(itemtwo)}}</a>
              </li>
            </ul>
          </li>
        </ul>
        <div class="fix"></div>
      </div>
      <!-- 手機選單 -->
      <div class="disp_con">
        <div class="cell_nav_box">
          <div class="cell_nav_close">
            <button type="button" class="cell_nav_close_btn"><img src="/../static/images/close.png"></button>
          </div>
          <div class="cell_nav">
            <ul class="menu">
              <li v-for="itemone in menu">
                <div class="title" @click="subMenu" v-if="itemone.children[0]" :var="itemone.id">
                  {{showTitle(itemone)}}
                </div>
                <div class="title clicknav" @click="subMenu" v-else>
                  <a @click="linkUrl(itemone)">{{showTitle(itemone)}}</a>
                </div>
                <div class="sub clicknav" :var="itemone.id" v-if="itemone.children[0]">
                  <ul>
                    <li v-for="itemtwo in itemone.children">
                      <a @click="linkUrl(itemtwo)">{{showTitle(itemtwo)}}</a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="disp_con">
        <a class="toggleMenu">
          <button type="button" class="cell_nav_open_btn"><i class="fa fa-bars" aria-hidden="true"></i></button>
        </a>
      </div>
      <!-- 手機選單 -->
    </div>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div class="con_all">
      <div class="con_one" v-if="$route.meta.keepAlive">
        <div class="con_one_left">
          <div id="carousel-example-generic" class="carousel slide" data-ride="carousel" style="overflow: hidden;height: 340px;position:relative;" v-if="noticepictures.length > '1'">
            <div class="carousel-inner" role="listbox">
              <div class="item active" v-for="(notice,index) in noticepictures" :key="notice.id" v-if="index == '0'">
                <a :target="target(notice)" :href="href(notice)" @click="pushToNewsSub(notice)">
                  <img :src="notice.pictures">
                  <div class="carousel-caption flex-caption" style="padding: 10px 20px;text-align: left;left: 0;">
                     {{notice.title}}
                  </div>
                  </a>
              </div>
              <div class="item" v-for="(notice,index) in noticepictures" :key="notice.id" v-if="index > '0' && index < '10'">
                <a :target="target(notice)" :href="href(notice)" @click="pushToNewsSub(notice)">
                  <img :src="notice.pictures">
                  <div class="carousel-caption flex-caption" style="padding: 10px 20px;text-align: left;left: 0;">
                     {{notice.title}}
                  </div>
                </a>
              </div>
            </div>
            <a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
            <a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
          </div>
          <div v-else-if="noticepictures[0]" style="height: 340px;position:relative;overflow: hidden;">
            <a :target="target(noticepictures[0])" :href="href(noticepictures[0])" @click="pushToNewsSub(noticepictures[0])">
                  <img :src="noticepictures[0].pictures" style="width: 100%;">
                  <div class="carousel-caption flex-caption" style="height: 40px; bottom:0;padding: 10px 20px;text-align: left;left: 0;">
                     {{noticepictures[0].title}}
                  </div>
                </a>
          </div>
        </div>
        <div class="con_one_right">
          <div class="abgne_tab">
            <div class="outertab">
              <ul class="tabs" style="margin-bottom: 0;">
                <!--<li  @click="selectType({id: 0})" key="news"><a>{{news}}</a></li>-->
                <li :class="{active:index===0}" v-if="type.homeDisplay === 1" v-for="(type,index) in types" :key="index" @click="selectType(type)"><a>{{showType(type)}}</a></li>
              </ul>
            </div>
            <HomeNotice :type="type" :notices='notices'></HomeNotice>
          </div>
        </div>
        <div class="fix"></div>
        <div class="con_one_left con_tim">
          <router-link :to="{ name: 'site'}" class="hoverimg">
            <img src="/../static/images/8.jpg">
            <div class="imgwrap">場地介紹</div>
          </router-link>
        </div>
        <div class="con_one_right">
          <iframe width="100%" height="315" :src="video.fileUrl" frameborder="0" allowfullscreen=""></iframe>
          <router-link :to="{ name: 'video'}">
            <button type="submit" class="more_btn fright">more</button>
          </router-link>
        </div>
        <div class="fix"></div>
      </div>
      <div class="con_title con_line" v-if="$route.meta.keepAlive && course && false">
        <router-link :to="{ name: 'class'}" style="color:#00907f">
          {{course.schoolYear}}{{academicYear}}{{showCourseName()}}
        </router-link>
      </div>
      <div class="con_two">
        <div class="flexslider" v-if="$route.meta.keepAlive && false">
          <ul class="slides">
            <li data-thumb="/../static/images/8.jpg" v-for="(classitem,index) in classes" :key="index" v-if="(index%4) == 0">
              <div class="bzbox">
                <table>
                  <tr>
                    <td><img v-if="classes[index]" :src="classes[index].pictureUrl" @click="pushToClassItem(classes[index].id)"></td>
                    <td><img v-if="classes[index+1]" :src="classes[index+1].pictureUrl" @click="pushToClassItem(classes[index+1].id)"></td>
                    <td><img v-if="classes[index+2]" :src="classes[index+2].pictureUrl" @click="pushToClassItem(classes[index+2].id)"></td>
                    <td><img v-if="classes[index+3]" :src="classes[index+3].pictureUrl" @click="pushToClassItem(classes[index+3].id)"></td>
                  </tr>
                </table>
              </div>
            </li>
          </ul>
        </div>
        <!--<div class="flexslider" style="height: 200px; border: 1px solid #000;" v-if="$route.meta.keepAlive">
                  這邊有輪播
                </div>-->
        <div class="footer_all mt40">
          <div class="footer_box">
            <div class="footer_left">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.422627912698!2d121.53430791500597!3d25.01972768397899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9882cdc64e7%3A0xcfaa4ee05f721105!2z5ZyL56uL6Ie654Gj5aSn5a246auU6IKy5a6k!5e0!3m2!1szh-TW!2stw!4v1515722591657" width="100%" height="350" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
            <div class="footer_right">
              <!-- <ul>
                <div class="pb10">{{footTitle}}</div>
                <li>{{footContent1}}</li>
                <li><i class="fa fa-phone mr5" aria-hidden="true"></i>(02)3366-5959</li>
                <li>{{footContent2}}</li>
              </ul> -->
              <div v-html="homeInfoCh" v-if="locale == 'CH'"></div>
              <div v-html="homeInfoEn" v-if="locale == 'EN'"></div>
              <!--{{links}}-->
              <div class="footer_link">
                <a target="_blank" :href="link.linkUrl" v-for="(link,index) in links" :key="index" v-if="link.isActive == 1 && link.trash != 1">
                  <img :src="link.pictureUrl">
                </a>
              </div>
              <div class="fix"></div>
            </div>
            <div class="fix"></div>
          </div>
        </div>
      </div>
      <div class="footer_copy">
        臺灣大學體育室版權所有 Copyright {{nowYear}} Department of Athletics, NTU All Rights Reserved
      </div>
    </div>
  </div>
  <!-- all_in -->
  </div>
</template>
<script>
import 'babel-polyfill';
// 原 jquery-latest.min.js（實為 jQuery 1.11.1，含 CVE-2020-11022）已移除，
// 其檔尾附加的頁籤切換邏輯抽出為 tabs.js，行為不變
import tabs from "@/assets/library/tabs.js";
import home from "@/../static/js/home.js";
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

import HomeNotice from '@/pages/HomeNotice.vue'

export default {
  name: 'home',
  components: {
    HomeNotice
  },
  data() {
    return {
      notices: [
        // {
        //  createdAt: '',
        //  title: '',
        //  typeId: '',
        // keepTop: '',
        // }
      ],
      types: [{
        id: 0,
        nameCh: '最新消息',
        nameEn: 'latest news',
        homeDisplay: 1
      }],
      type: { id: 0 },
      noticepictures: [],
      videos: [],
      video: '',
      menu: [],
      course: {},
      classes: [],
      alert: [],
      modal: false,
      nowRocYear: '',
      links: [],
      locale: sessionStorage.getItem('locale'),
      news: { CH: '最新消息', 　EN: 'latest news' },
      academicYear: { CH: '學年度', EN: ' Academic Year ' },
      homeTitle: { CH: '臺灣大學體育室', EN: 'Department of Athletics, NTU' },
      footTitle: { CH: '國立臺灣大學體育室', EN: 'National Taiwan University Gymnasium' },

      footContent1: { CH: '地址：臺北市羅斯福路四段一號', EN: 'Address: No. 1, Sec. 4, Roosevelt Road, Taipei, 10617 Taiwan(R.O.C)' },
      footContent2: {
        CH: '信箱：ntupe@ntu.edu.tw',
        EN: 'Mail：ntupe@ntu.edu.tw'
      },

      homeInfoCh: "",
      homeInfoEn: "",
      nowYear: '',

    };
  },
  created() {
    if (!sessionStorage.locale) {
      sessionStorage.setItem('locale', 'CH');
      this.locale = 'CH';
    }
    this.nowYear = (new Date()).getFullYear()
    this.init();
  },

  mounted: function() {
    this.$nextTick(function() {
      tabs.init()
    })
  },
  updated: function() {
    tabs.init()
    home.init()
    home.test()
  },

  methods: {
    init() {
      this.showPage();
      this.initNowRocYear()
      this.initNotice();
      this.initTypes();
      this.initVideo();
      this.initMenu();
      this.initCourse()

      this.initLinks();
      this.getAlert();
    },

    initNowRocYear() {
      let now = new Date();
      this.nowRocYear = now.getFullYear() - 1910;
    },
    initTypes() {
      this.getTypesData();
    },
    initNotice() {
      this.getNoticeData();
    },
    initVideo() {
      this.getVideoData();
    },
    initMenu() {
      this.getMenuData();
    },
    initCourse() {
      this.getCourseData();
    },
    initClasses() {
      this.getClassesData();
    },
    initLinks() {
      this.getlinksData();
    },
    getAlert() {
      axios.get(API.setting + `?id=1`)
        .then(response => {
          this.alert = response.data
          this.homeInfoCh = response.data.homeInfoCh
          this.homeInfoEn = response.data.homeInfoEn
        })
        .then(() => {
          if (this.alert && this.alert.isActive == 1) {
            alert(this.alert.context);
            // this.modal = true
          }
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getNoticeData() {
      axios.get(API.notice + `?groupTop=8`)
        .then(response => {
          this.notices = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.handleReceivedNotices();
          this.getNoticePictures();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getTypesData() {
      axios.get(API.code + `?type=2`)
        .then(response => {
          this.types = this.types.concat(response.data.filter(data => {
            return data.trash !== 1 && data.homeDisplay === 1;
          }));
          // this.type = this.types.filter(type => {
          //   return type.homeDisplay === 1;
          // })[0];
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getVideoData() {
      axios.get(API.video)
        .then(response => {
          this.videos = response.data;
          while (1) {
            let random = Math.floor(Math.random() * (this.videos.length));
            if (this.videos[random].fileUrl) {
              this.video = this.videos[random];
              break;
            }
          }
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getMenuData() {
      axios.get(API.menu + '/tree')
        .then(response => {
          this.menu = response.data.baseData;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getNoticePictures() {
      this.notices.forEach(notice => {
        if (notice.pictures) {
          notice.pictures.forEach(picture => {
            if (!picture.file_url) return;
            let newnotice = Object.assign({}, notice);
            newnotice.pictures = picture.file_url;
            this.noticepictures.push(newnotice);
          }, this)
        }
      }, this);
    },
    getCourseData() {
      axios.get(API.course)
        // axios.get(API.course + '?id=1')
        .then(response => {
          var course = response.data.filter(data => {
            return data.trash !== 1;
          })
          this.course = course[course.length - 1];
        }).then(() => {
          this.initClasses();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getClassesData() {
      axios.get(API.class + `?courseid=${this.course.id}`)
        .then(response => {
          this.classes = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getlinksData() {
      axios.get(API.link)
        .then(response => {
          this.links = response.data.filter(data => {
            return data.trash !== 1 && data.isActive === 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    handleReceivedNotices() {
      this.notices.sort((a, b) => {
        let ac = a.createdAt.split(' '),
          acd = ac[0].split('-'),
          act = ac[1].split(':'),
          bc = b.createdAt.split(' '),
          bcd = bc[0].split('-'),
          bct = bc[1].split(':');
        let aDate = new Date(acd[0], acd[1] - 1, acd[2], act[0], act[1], act[2]),
          bDate = new Date(bcd[0], bcd[1] - 1, bcd[2], bct[0], bct[1], bct[2]);

        if (aDate.getTime() < bDate.getTime())
          return 1;
        return -1;
      });
    },
    pushToClassItem(id) {
      this.$router.push({ name: 'class_item', params: { classid: id } });
    },
    selectType(type) {
      this.type = type;
    },
    subMenu(data) {
      if (data.target.attributes.var) {
        $(`.sub[var="${data.target.attributes.var.value}"]`).slideToggle();
      } else {
        $('.sub').slideUp();
      }
    },

    pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.newsitem = newsitem;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink)
        return newsitem.externalLink;
      return undefined;
    },


    setLocale(lanuage) {
      sessionStorage.setItem('locale', lanuage);
      if (this.$route.name === 'coach_info' || this.$route.name === 'facility' || this.$route.name === 'class_inside')
        this.$router.push({ name: 'class_item', params: { classid: this.$route.params.classid } })
      window.location.reload();
    },
    showPage() {
      this.academicYear = this.academicYear[this.locale];
      this.homeTitle = this.homeTitle[this.locale];
      this.footTitle = this.footTitle[this.locale];
      this.footContent1 = this.footContent1[this.locale];
      this.footContent2 = this.footContent2[this.locale];
      this.news = this.news[this.locale];
    },
    showTitle(itemone) {
      return sessionStorage.locale === 'CH' ? itemone.titleCh : itemone.titleEn;
    },
    showType(type) {
      return sessionStorage.locale === 'CH' ? type.nameCh : type.nameEn;
    },
    showCourseName() {
      let show = { CH: this.course.nameCh, EN: this.course.nameEn };
      return show[sessionStorage.locale];
    },
    checkTitle(itemone) {
      let show = { CH: itemone.titleCh, EN: itemone.titleEn };
      return show[sessionStorage.locale] ? true : false;
    },
    linkUrl(item) {
      if (item.linkUrl.includes('http')) {
        if (item.openMode == 2) {
          window.open(item.linkUrl, '_blank')
        } else {
          location.href = item.linkUrl;
        }
      } else {
        location.href = '#/' + item.linkUrl;
      }
    }
  },
}

</script>
<style lang="scss">
@import "/../static/css/plugins.css";
@import "/../static/css/toastr.css";
@import "/../static/css/set.css";
@import "/../static/css/rwd.css";
@import "/../static/css/index_tabs.css";
@import "/../static/css/flexslider.css";
#home {
  .breadcrumbs {
    ul {
      li {
        &:after {
          content: ">";
          padding-left: 10px;
        }
        &:last-child {
          &:after {
            content: "";
          }
        }
      }
    }
  }
  .gsc-search-button-v2 {
    padding: 4px 6px;
    height: 24px;
    width: 28px;
  }
  .gsc-control-cse {
    padding: 0;
  }
  #gs_tti50 {
    padding: 2px 6px;
    .gsc-input {
      height: 1em !important;
    }
  }
  .bzbox {
    tr {
      td {
        img {
          cursor: pointer;
        }
      }
    }
  }
}

// .note-group-select-from-files {
//   display: none;
// }
.vertical-center-modal-cus {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999999999;
  .ivu-modal {
    top: 0;
  }
  .ivu-modal-body {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ivu-modal-footer {
    border-top: 0;
    padding: 0;
  }
}

b {
  font-weight: bold;
}

i {
  font-style: italic;
}

.con_one_left.con_tim {
  position: relative
}

.hoverimg {
  .imgwrap {
    position: absolute;
    bottom: 0;
    left: 42%;
    top: 50%;
    font-size: 30px;
    color: #fff;
    opacity: 0;
  }
  &:hover {
    .imgwrap {
      opacity: 1;
      transition: .3s;
    }
    img {
      opacity: .8;
      transition: .3s;
    }
  }
}

.flex-caption {
  bottom: 0;
}
#carousel-example-generic .item img {
    height: 340px;
    width: 100%;
    object-fit: cover;
}

</style>



// WEBPACK FOOTER //
// Home.vue?3f8df243